import Button from 'common/components/button'
import { ArrowRight as ArrowRightIcon } from 'common/icons'

import { PageState } from './BriefPage'

type Props = {
  brief: string
  pageState: PageState
}

const GeneratedBrief = ({ brief, pageState }: Props) => {
  return (
    <>
      {pageState === 'generateTopics' && (
        <div className="flex flex-col mb-6 border border-coolGray-300 rounded-md p-6 bg-white">
          <div className="text-sm font-medium text-orange-500">
            Phrasee has generated your brief
          </div>
          <div className="text-sm text-coolGray-500">
            We will use this Phrasee engineered brief to generate your content.
          </div>
          <div className="mt-6 text-base text-coolGray-800">{brief}</div>
          <div className="flex pt-6 justify-end items-center">
            <Button
              type="submit"
              data-cy="content-generate-brief-button"
              variant="primary"
              suffixIcon={<ArrowRightIcon isDefaultColor={false} size={4} />}
            >
              Generate topics
            </Button>
          </div>
        </div>
      )}
    </>
  )
}

export default GeneratedBrief
